
export const serverUrl={
    aws:'https://pyd0xvkp5g.execute-api.ap-south-1.amazonaws.com/default',
    web:'https://web.alistetechnologies.com',
    sub:'https://subscriptioncloud.alistetechnologies.com',
    thermoAws:'https://q2c544kuqd.execute-api.ap-south-1.amazonaws.com',
    weatherAws:'https://hp92ovh6r0.execute-api.ap-south-1.amazonaws.com/default',
    environAws:'https://mzcdl7akp0.execute-api.ap-south-1.amazonaws.com',
    megaController:'https://v1yebqn9j8.execute-api.ap-south-1.amazonaws.com/default',
    doorSensor:'https://pczpa0az51.execute-api.ap-south-1.amazonaws.com/default',
    mqttConnectionStatus:'https://keiozfbox5.execute-api.ap-south-1.amazonaws.com/default',
    subTest:'https://test.alistetechnologies.com:9443',
    vrvController:'https://vrvcontroller.main.aliste.io',
    // JFL auth service. Left as a same-origin path on purpose: the access,
    // refresh and csrf cookies it sets are SameSite=Strict, so the browser only
    // sends them back when the request is same-site. setupProxy.js forwards
    // /staging to the API in development; production needs the same rewrite in
    // front of the app - on Amplify that is the first rule in
    // amplify-redirects.json, which has to be applied in the console because
    // Amplify Hosting does not read redirect rules from the repo.
    // Point REACT_APP_JFL_AUTH_URL at the API host directly only once that host
    // serves CORS and SameSite=None cookies.
    //
    // The stage defaults to staging. Changing it means changing it everywhere it
    // appears - here, setupProxy.js, amplify-redirects.json, and the
    // __Secure-refresh_token cookie path the service itself sets - because a
    // mismatch shows up as a 403 on token refresh, not as an obvious failure.
    // REACT_APP_JFL_API_HOST is deliberately NOT used here: it is the proxy's
    // target, read by setupProxy.js on the Node side. Building the browser's
    // baseURL from it sends every call cross-origin, which the service answers
    // with a CORS error and which the SameSite=Strict cookies never survive.
    jflAuth:
        process.env.REACT_APP_JFL_AUTH_URL ||
        `/${process.env.REACT_APP_JFL_STAGE || 'staging'}`,
}

export const pages = {
    schedulePage:'schedule',
    megaControllerPage:'megacontroller',
}